// BR 巴西逻辑

import { get } from 'lodash'
export default function transformer(data = {}, dateToWeek = {}, key = 'menu') {
  const { name, period, indicators } = data
  return {
    title: name,
    period,
    indicators,
    itemTop10: get(data, 'listData.itemTop10', []),
    chartkey: key,
  }
}
